//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/DiagrammingLibraryAuthor.js";
import "../no/TaggedObject.js";
import "../Tooling/Tooling.SelectReuseLibraryItemBuilder.js";
import "../DiagrammingLibraryAuthor/DiagrammingLibraryAuthor.PortDataBuilder.js";
import "../no/ugmath.js";
import "../no/Gateway.js";
import "../no/Tooling.js";
let d=[[[0,"AnchorPoint",1,0],[1,"DraftingSymbol",0,"Tooling.SelectReuseLibraryItemBuilder",0],[0,"EnableScale",1,0],[0,"Image",1,"Gateway.ImageCaptureBuilder",0],[0,"IsInline",1,0],[1,"PortData",0,"DiagrammingLibraryAuthor.PortDataBuilder",0],[0,"PrefixLetters",1,0],[0,"TagLocation",1,0]],[[["symbolId"],"CreateFromSymbol",{},1,0],[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.DiagrammingLibraryAuthor.Symbol2DBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.DiagrammingLibraryAuthor.Symbol2DBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;